import { defineComponent as O, createElementBlock as a, openBlock as o, createElementVNode as s, renderSlot as f, createCommentVNode as l, normalizeClass as A, unref as r, createTextVNode as h, withModifiers as $, createVNode as b, withCtx as k, toDisplayString as p, createBlock as E, normalizeStyle as N } from "vue";
import { ScalarSidebarGroupToggle as V } from "@scalar/components";
import { scrollToId as H } from "@scalar/helpers/dom/scroll-to-id";
import { getHttpMethodInfo as I } from "@scalar/helpers/http/http-info";
import { sleep as v } from "@scalar/helpers/testing/sleep";
import { ScalarIconWebhooksLogo as P } from "@scalar/icons";
import { isOperationDeprecated as R, combineUrlAndPath as U } from "@scalar/oas-utils/helpers";
import { useConfig as D } from "../../../hooks/useConfig.js";
import { useNavState as L } from "../../../hooks/useNavState.js";
import M from "./SidebarHttpBadge.vue.js";
const z = ["id"], j = {
  key: 0,
  class: "sidebar-heading-chevron"
}, F = ["aria-expanded"], G = ["href", "tabindex"], W = { class: "sidebar-heading-link-title" }, q = {
  key: 0,
  class: "hanging-indent"
}, J = { key: 1 }, K = {
  key: 0,
  class: "sidebar-heading-link-method"
}, Q = {
  key: 1,
  class: "action-menu"
}, ae = /* @__PURE__ */ O({
  __name: "SidebarElement",
  props: {
    id: {},
    item: {},
    isActive: { type: Boolean },
    hasChildren: { type: Boolean },
    open: { type: Boolean }
  },
  emits: ["toggleOpen"],
  setup(y, { emit: C }) {
    const i = y, m = C, { getFullHash: u, isIntersectionEnabled: d, replaceUrlState: w } = L(), n = D(), S = (e) => "path" in e ? e.path.replace(/\//g, "/​") : e.title, c = async () => {
      d.value = !1, i.hasChildren && m("toggleOpen"), await v(100), d.value = !0;
    }, T = () => {
      if (n.value.pathRouting)
        return U(n.value.pathRouting.basePath, i.item.id);
      if (typeof window < "u") {
        const e = new URL(window.location.href);
        return e.hash = u(i.item.id), `${e.search}${e.hash}`;
      }
      return `#${u(i.item.id)}`;
    }, B = async (e) => {
      var t, g;
      (g = (t = n.value).onSidebarClick) == null || g.call(t, i.item.id), n.value.pathRouting && (e.preventDefault(), i.hasChildren && m("toggleOpen"), m("toggleOpen"), d.value = !1, w(i.item.id), H(i.item.id), await v(100), d.value = !0);
    };
    return (e, t) => (o(), a("li", {
      id: e.id,
      class: "sidebar-group-item"
    }, [
      s("div", {
        class: A(["sidebar-heading", {
          "sidebar-group-item__folder": e.hasChildren,
          active_page: e.isActive,
          deprecated: "operation" in e.item && r(R)(
            e.item.operation
          )
        }]),
        onClick: c
      }, [
        e.hasChildren && !r(n).defaultOpenAllTags ? (o(), a("p", j, [
          s("button", {
            "aria-expanded": e.open,
            class: "toggle-nested-icon",
            type: "button",
            onClick: $(c, ["stop"])
          }, [
            b(r(V), { open: e.open }, {
              label: k(() => [
                h(p(e.open ? "Collapse" : "Expand") + " " + p(e.item.title), 1)
              ]),
              _: 1
            }, 8, ["open"])
          ], 8, F),
          t[0] || (t[0] = h("   "))
        ])) : l("", !0),
        s("a", {
          class: "sidebar-heading-link",
          href: T(),
          tabindex: e.hasChildren ? -1 : 0,
          onClick: B
        }, [
          s("p", W, [
            r(n).operationTitleSource === "path" ? (o(), a("span", q, p(S(e.item)), 1)) : (o(), a("span", J, p(e.item.title), 1))
          ]),
          "method" in e.item && !e.hasChildren ? (o(), a("p", K, [
            t[1] || (t[1] = h("   ")),
            t[2] || (t[2] = s("span", { class: "sr-only" }, "HTTP Method: ", -1)),
            b(M, {
              active: e.isActive,
              class: "min-w-9.75 justify-end text-right",
              method: e.item.method
            }, {
              default: k(() => [
                "webhook" in e.item ? (o(), E(r(P), {
                  key: 0,
                  style: N({
                    color: r(I)(e.item.method).colorVar
                  }),
                  weight: "bold"
                }, null, 8, ["style"])) : l("", !0)
              ]),
              _: 1
            }, 8, ["active", "method"])
          ])) : l("", !0)
        ], 8, G)
      ], 2),
      e.open ? f(e.$slots, "default", { key: 0 }, void 0, !0) : l("", !0),
      e.$slots["action-menu"] ? (o(), a("div", Q, [
        f(e.$slots, "action-menu", {}, void 0, !0)
      ])) : l("", !0)
    ], 8, z));
  }
});
export {
  ae as default
};
